import { connect } from 'react-redux';

import { CompositeSessionInfoSelectors } from '~selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~selectors/SiteUrlsSelectors';
import { MapDispatchToProps, MapStateToProps } from '~src/app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { contentCountsUpToDate } from '~src/spacesPlatform/actions/ContentCountsActions';
import { addContentFavorite, removeContentFavorite } from '~src/spacesPlatform/actions/FavoritesActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { selectContentCounts, selectContentCountsUpToDate } from '~src/spacesPlatform/selectors/ContentCountsSelector';
import { PublishedConnectionTableSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { enterPublishedConnectionTableSubspace } from '../actions/EnterPublishedConnectionTableSubspaceAction';
import { publishedConnectionTableCountsRequest } from '../actions/PublishedConnectionTableCountsRequestAction';
import {
  PublishedConnectionTableSpace,
  PublishedConnectionTableSpaceDispatchProps,
  PublishedConnectionTableSpaceOwnProps,
  PublishedConnectionTableSpaceStateProps,
} from './PublishedConnectionTableSpace';

const mapStateToProps: MapStateToProps<PublishedConnectionTableSpaceStateProps> = (state) => ({
  contentCountsPublishedConnectionTable: selectContentCounts<'virtualConnectionTable'>(state, 'virtualConnectionTable'),
  urls: siteUrlsSelector(state),
  contentCountsUpToDate: selectContentCountsUpToDate(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<PublishedConnectionTableSpaceDispatchProps, PublishedConnectionTableSpaceOwnProps> = (dispatch, ownProps) => ({
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
  enterSpace: (requestContent: boolean) => {
    dispatch(enterPublishedConnectionTableSubspace(
      ownProps.publishedConnectionTableDetailInfo,
      ownProps.subplaceName as PublishedConnectionTableSubspaceName,
      requestContent
    ));
  },
  fetchUpdatedContentCounts: () => {
    dispatch(publishedConnectionTableCountsRequest('virtualConnectionTable'));
  },
  markContentCountsUpToDate: () => {
    dispatch(contentCountsUpToDate());
  },
  populateContentBreadcrumbs,
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.publishedConnectionTableDetailInfo));
  },
});

export const ConnectedPublishedConnectionTableSpace = connect(mapStateToProps, mapDispatchToProps)(PublishedConnectionTableSpace);
